import React from 'react'

import { useFormState } from '../form/form/FormHandler'
import Form from '../form/form/Form'

export const useGenericState = () => {
  const state = useFormState()
  return { ...state, value: state.form }
}

const GenericState = ({ children, ...props }) => {
  return <Form {...props}>{children}</Form>
}

export default GenericState
